import React, { Component } from 'react'
import LogoLittleShooting from './common/Logo-LittleShooting'
import {login, createUser, pwdreminder} from '../actions/actions'
import { withRouter } from 'react-router';
import { Link } from 'react-router-dom'


class Login extends Component {
	state = {
		// email: 'gs-accounts+kitten@grand-shooting.com',
		// password: 'CfQWkB2nAr9E',
		email:'',
		password:'',
		err:null,
		sendEmail:false,
		phase:"createUser"
	}

	goto = () => {
		//TODO : On redirige vers le tunnel d'achat ou l'espace perso suivant le cas
		console.log("this.props.history.location.search = ", this.props.history.location.search)
		if (this.props.history.location.search.indexOf('?goto=') === 0) {
			const go = this.props.history.location.search.replace('?goto=', '')
			this.props.history.replace('/' + go)
		} else {
			this.props.history.push("/")
		}
	}

	submit = e => {
		e.preventDefault()
		e.stopPropagation()
		if(this.state.phase === "forgot") {
			pwdreminder(this.state.email).then(ok => {
				if(ok) {
					this.setState({err : "Un email vous a été envoyé pour réinitialiser votre mot de passe", sendEmail:true})
				} else {
					this.setState({err : "Votre email nous est inconnu"})
				}
			})
		} else if(this.state.phase === "createUser") {
			createUser({
				email:this.state.email,
				password:this.state.password,
				password_again:this.state.password,
				cgu_version:3,
				company:this.state.email,
				accounttype:30
			}).then(ok => {
				this.goto()
			}).catch(err=> {
				this.setState({err : "Un compte existe déjà pour votre email"})
			})
		} else {
			login(this.state.email, this.state.password).then( () => {
				this.goto()
			}).catch(e => this.setState({err:"Login ou mot de passe incorrect"}))
		}
		return false
	}

	render() {
		var form = []
		var link = []
		var back = []
		var desc = []
		if(this.state.phase === "forgot") {
			link = 	<div className="txtright"><span className="d-inbl tiny-w100 u-small">Vous n'êtes pas encore inscrit&nbsp;?</span><a href="#" className="tiny-mts tiny-mls mlm btn--primary" onClick={() => this.setState({phase:"createUser"})}>Créer un compte</a></div>
			back = 	<div className="tiny-ptm small-ptm ptl pbl"><Link className="btn--unstyled u-secondary-bold u-big" to="/"><span className="prs">&#60;</span>Retour à la liste des offres</Link></div>
			desc = 	<div><h1 className="h3-like">Mot de passe oublié&nbsp;?</h1><p className="pts ma0">Renseignez votre adresse email, nous vous indiquerons comment choisir un nouveau mot de passe.</p></div>
			form = 	<form className="tiny-ptm ptl pbm" onSubmit={this.submit}>
						{this.state.sendEmail ? [] : [
							<div className="pbl"><input className="w100" type="email" value={this.state.email} onChange={e => this.setState({email:e.target.value})}/></div>,
							<button className="btn--secondary btn--big" type="submit">Envoyez-moi un email</button>
							]
						}
						<p className="color--primary-darken u-small">{this.state.err}</p>
					</form>
		} else if(this.state.phase == "createUser") {
			link = 	<div className="txtright"><span className="d-inbl tiny-w100 u-small">Vous avez déjà un compte&nbsp;?</span><a href="#" className="tiny-mts tiny-mls mlm btn--primary" onClick={() => this.setState({phase:"connect"})}>Se connecter</a></div>
			back =	 <div className="tiny-ptm ptl pbl"><Link className="btn--unstyled u-secondary-bold u-big" to="/"><span className="prs">&#60;</span>Retour à la liste des offres</Link></div>
			desc = 	<div><h1 className="h3-like">Devenez un client heureux avec de belles images</h1><p className="pts ma0">Quelques informations pour passer commande</p></div>
			form = 	<form className="tiny-ptm ptl pbm" onSubmit={this.submit}>
						<div className="pbm"><input className="w100" placeholder='Email' type="email" value={this.state.email} onChange={e => this.setState({email:e.target.value})}/></div>
						<div className="pbm"><input className="w100" placeholder='Mot de passe' type="password" value={this.state.password} onChange={e => this.setState({password:e.target.value})}/></div>
						<p className="u-small tiny-pts tiny-pb0 ptm pbm">En cliquant sur "S'inscrire", je reconnais avoir pris connaissance des <a href="/help/cgv" className="color--primary-darken">conditions générales de vente</a> et je les accepte.</p>
						<p className="color--primary-darken u-small">{this.state.err}</p>
						<div className="ptm"><button className="btn--secondary btn--big" type="submit">S'inscrire</button></div>
					</form>
		} else {
			link = 	<div className="txtright"><span className="d-inbl tiny-w100 u-small">Vous n'êtes pas encore inscrit&nbsp;?</span><a href="#" className="tiny-mts tiny-mls mlm btn--primary" onClick={() => this.setState({phase:"createUser"})}>Créer un compte</a></div>
			back = 	<div className="tiny-ptm ptl pbl"><Link className="btn--unstyled u-secondary-bold u-big" to="/"><span className="prs">&#60;</span>Retour à la liste des offres</Link></div>
			desc =  <div><h1 className="h3-like">Content de vous revoir&nbsp;!</h1><p className="pts ma0">Authentifiez-vous pour passer commande</p></div>
			form = 	<form className="tiny-pts ptm pbm" onSubmit={this.submit}>
						<div className="tiny-pbm pbl"><a href="#" className="color--primary-darken u-small italic" onClick={() => this.setState({phase:"forgot"})}>J'ai oublié mon mot de passe</a></div>
						<div className="pbm"><input className="w100" placeholder='Email' type="email" value={this.state.email} onChange={e => this.setState({email:e.target.value})}/></div>
						<div className="pbm"><input className="w100" placeholder='Mot de passe' type="password" value={this.state.password} onChange={e => this.setState({password:e.target.value})}/></div>
						<p className="color--primary-darken u-small">{this.state.err}</p>
						<div className="tiny-pt0 ptm"><button className="btn--secondary btn--big" type="submit">Se connecter</button></div>
					</form>
		}
		return (
			<main id="login" className="pos-f w100 h100 d-flex zi4 flex-item-noshrink" role="main">
				<section className="w40 tiny-h10 tiny-w100 color--inverse bgc--primary pbxl pll prl tiny-pl0 tiny-pr0">
					<div className="h1-like right tiny-inbl tiny-w60 small-w100 medium-w80 large-w70 extra-large-w60 tiny-ptt ptl tiny-prl tiny-pll medium-prm large-prl extra-large-prl mts">
						<LogoLittleShooting className="logo-littleshooting"/>
						<span className="visually-hidden">Little Shooting</span>
					</div>
					<div className="pos-a mauto tiny-hidden w100 ptm">
						<img className="w50 small-w60 large-pll extra-large-plxl ptl flip-h" src="/assets/images/basket.png" alt=""/>
					</div>
					<div className="is-hidden tiny-visible w40 fr pts">
						<img className="w90 flip-h" src="/assets/images/basket.png" alt=""/>
					</div>
				</section>
				<section className="d-flex w60 tiny-h90 tiny-w100 bgc--inverse large-plxl extra-large-plxl prs zi1">
					<div className="w100 h100 large-prxl extra-large-prxl pll prl ptm pbm custom-scrollbar custom-v-scrollbar v-auto-scrollbar">
						{link}
						{back}
						{desc}
						{form}
					</div>
				</section>
			</main>
		)
	}
}

export default withRouter(Login)


// WEBPACK FOOTER //
// ./src/components/Login.js